import React from "react";
import { Box, Text, Heading, Button } from "samba-ui";

const ServerErrorPage = ({ error }) => {
  return (
    <Box textAlign="center" mt={132}>
      <Text fontSize={200} fontWeight={700} letterSpacing={4} color="#F6F8FA">
        500
      </Text>
      <Heading fontSize={5} fontWeight={600}>
        Internal server error
      </Heading>
      <Box mb={3}>
        <Text>An unexpected error occured. Try refreshing the page.</Text>
      </Box>
      <Button onClick={() => (window.location.href = "/")}>
        Return to home
      </Button>
    </Box>
  );
};

export default ServerErrorPage;
